// src/hooks/useScrollPosition.js
import {useCallback} from 'react';

const useScrollPosition = (scrollContainerRef) => {
    const savePosition = useCallback(() => {
        if (scrollContainerRef?.current) {
            const position = scrollContainerRef.current.scrollTop;
            sessionStorage.setItem('reservListScroll', position.toString());
            console.log('💾 Хук сохранил позицию:', position);
            return position;
        }
        return 0;
    }, [scrollContainerRef]);

    const restorePosition = useCallback(() => {
        const saved = sessionStorage.getItem('reservListScroll');
        if (saved) {
            const position = parseInt(saved, 10);
            console.log('🎯 Хук восстанавливает:', position);

            setTimeout(() => {
                if (scrollContainerRef?.current) {
                    scrollContainerRef.current.scrollTop = position;
                    console.log('✅ Хук восстановил позицию');
                }
            }, 100);
        }
    }, [scrollContainerRef]);

    return {savePosition, restorePosition};
};

export default useScrollPosition;
